import { JulianDate, Cartesian3, TimeIntervalCollection, TimeInterval, CallbackProperty, ConstantProperty, Entity, VelocityVectorProperty, } from "cesium";
import { computeErrorEllipsoid, getOrbitAndTraceSamplesFromStateVector, getStateVector, } from ".";
export const getCDMObjectAttributes = (tca, cdm, objectId) => {
    const object = cdm.objectStates[objectId];
    const sv = getStateVector(object.stateVector);
    const { orbitPositions: position, orbitPeriod } = getOrbitAndTraceSamplesFromStateVector(sv, tca);
    const availability = availabilityFromObject(tca, orbitPeriod);
    const velocity = new VelocityVectorProperty(position, false);
    const vector = getPositions(position, velocity);
    const { orientation, radii } = computeErrorEllipsoid(object.covarianceMatrix, position, velocity);
    return {
        name: object.objectFix.objectName,
        position,
        velocity,
        orbitPeriod,
        availability,
        vector,
        orientation,
        radii,
    };
};
export const getCameraBPPointAndPlaneEntity = (position, velocity, positionSecondary, velocitySecondary, tca, fustrum) => {
    const posECF = position.getValue(tca);
    const pos2ECF = positionSecondary.getValue(tca);
    const vel = velocity.getValue(tca);
    const vel2 = velocitySecondary.getValue(tca);
    let relativeVelocityDirection = Cartesian3.UNIT_Z;
    if (vel !== undefined || vel2 !== undefined || posECF !== undefined) {
        relativeVelocityDirection = Cartesian3.subtract(vel2, vel, new Cartesian3());
        Cartesian3.normalize(relativeVelocityDirection, relativeVelocityDirection);
    }
    const distance = Cartesian3.distance(posECF, pos2ECF);
    const tanFov = Math.tan(fustrum.fov / 3);
    const midPoint = Cartesian3.midpoint(posECF, pos2ECF, new Cartesian3());
    const cameraDistance = distance / tanFov;
    const cameraDelta = Cartesian3.multiplyByScalar(relativeVelocityDirection, cameraDistance, new Cartesian3());
    const cameraPosition = Cartesian3.add(midPoint, cameraDelta, new Cartesian3());
    const cameraOffsetVector = Cartesian3.subtract(cameraPosition, midPoint, new Cartesian3());
    const cameraOffsetVectorMagnitude = Cartesian3.magnitude(cameraOffsetVector);
    const fixedCameraOffsetVector = cameraOffsetVectorMagnitude > 1
        ? cameraOffsetVector
        : Cartesian3.multiplyByScalar(cameraOffsetVector, 1 / cameraOffsetVectorMagnitude + 1, new Cartesian3());
    const cameraOffsetProperty = new ConstantProperty(fixedCameraOffsetVector);
    return new Entity({
        position: midPoint,
        viewFrom: cameraOffsetProperty,
    });
};
export const availabilityFromObject = (tca, period) => {
    const start = JulianDate.addSeconds(tca, -period / 2.0, new JulianDate());
    const stop = JulianDate.addSeconds(tca, period / 2.0, new JulianDate());
    return new TimeIntervalCollection([
        new TimeInterval({
            start: start,
            stop: stop,
        }),
    ]);
};
export const getPositions = (position, velocity) => new CallbackProperty(function (time) {
    const posECF = position.getValue(time);
    const vel = velocity.getValue(time);
    if (vel === undefined || posECF === undefined) {
        return [];
    }
    const endPoint = Cartesian3.add(posECF, vel, new Cartesian3());
    return [posECF, endPoint];
}, false);
export const getRelativeVelocityPositions = (position, velocity, velocitySecondary) => new CallbackProperty(function (time) {
    const posECF = position.getValue(time);
    const vel = velocity.getValue(time);
    const vel2 = velocitySecondary.getValue(time);
    if (vel === undefined || vel2 === undefined || posECF === undefined) {
        return [];
    }
    const relativeVelocity = Cartesian3.subtract(vel2, vel, new Cartesian3());
    const endPoint = Cartesian3.add(posECF, relativeVelocity, new Cartesian3());
    return [posECF, endPoint];
}, false);
export const getCDMDescription = (cdm) => {
    return `
      <table style="width:100%">
      <tr>
        <th>Key</th>
        <th>Value</th>
      </tr>
      <tr>
      <td><strong>Message id</strong></td>
      <td>${cdm.messageId}</td>
    </tr>
    <tr>
    <td><strong>TCA</strong></td>
    <td>${cdm.tca}</td>
    </tr>
    <tr>
    <td><strong>Risk Level</strong></td>
    </tr>
      <tr>
      <td><strong>Primary Name </strong></td>
      <td>${cdm.primaryObject.objectFix.objectName}</td>
    </tr>
    <tr>
    <td><strong>Primary Int-des</strong></td>
    <td>${cdm.primaryObject.objectFix.internationalDesignator}</td>
    </tr>
    <tr>
    <td><strong>Secondary Name</strong></td>
    <td>${cdm.secondaryObject.objectFix.objectName}</td>
    </tr>
    <tr>
    <td><strong>Secondary Int-des</strong></td>
    <td>${cdm.secondaryObject.objectFix.internationalDesignator}</td>
    </tr>
    </table>
    `;
};
//# sourceMappingURL=conjunction.js.map